import React from 'react';

import { APIObject } from 'services/api';

export const APIContext = React.createContext<APIObject | undefined>(undefined);
